const interfacePhrases = {
    rate_limited: 'محدودیت نرخ',
    limit_exceeded: 'عبور از سقف مجاز',
    used: 'استفاده',
    identifier: 'شناسه',
    verification: 'تأیید',
    messages: 'پیام‌ها',
    data: 'داده‌ها',
    custom: 'سفارشی',
    management_api: 'رابط مدیریت {{product}}',
    management_api_role_description: 'این نقش داخلی دسترسی به رابط مدیریت را فراهم می‌کند.',
    client_credentials: 'اطلاعات احراز هویت کلاینت',
    authentication_request: 'درخواست احراز هویت',
    callback: 'بازگشت احراز هویت',
    help_title: 'مرکز راهنمای iden',
    help_subtitle: 'راهنمایی بدون خروج از فضای کاری',
    open_help: 'باز کردن صفحه کامل راهنما',
    close_help: 'بستن راهنما',
    about: 'درباره و متن‌باز',
    open_navigation: 'باز کردن ناوبری',
    close_navigation: 'بستن ناوبری',
    development_enabled: 'قابلیت‌های توسعه فعال شد',
    beta: 'آزمایشی',
    impersonation: 'ورود به‌جای کاربر',
    key: 'کلید',
    value: 'مقدار',
    error: 'خطا',
    details: 'جزئیات فنی',
    callback_failed: 'تکمیل بازگشت ورود امکان‌پذیر نبود.',
    back_sign_in: 'بازگشت به ورود',
    powered_by: 'با پشتیبانی',
    avatar: 'تصویر نمایه',
    logo: 'نشان',
    qr_code: 'کد QR',
    sample_title: 'می‌خواهید نمونه‌ای ببینید؟',
    sample_description: 'یک برنامه نمونه که از این راهنما استفاده می‌کند را بررسی کنید.',
    sample_action: 'مشاهده نمونه',
    further_readings: 'مطالعه بیشتر',
    complete_guide: 'راهنمای کامل',
    custom_domains_notice: 'پس از افزودن <a>دامنه‌های سفارشی</a> می‌توانید از این نقطه پایانی استفاده کنید: <code>{{endpoint}}</code>.',
    my_project: 'پروژه من',
    my_secret: 'رمز محرمانه من',
    my_token: 'توکن من',
    role_example: 'خواننده',
    reset_retry: 'بازنشانی تنظیمات و تلاش دوباره',
    open_dev_panel: 'باز کردن پنل توسعه‌دهنده',
    close_dev_panel: 'بستن پنل توسعه‌دهنده',
    configuration: 'تنظیمات',
    app_id: 'شناسه برنامه',
    extra_parameters: 'پارامترهای اضافی ورود',
    prompt: 'درخواست احراز هویت',
    scope: 'دامنه دسترسی',
    resource: 'منبع',
    resources_space_delimited: 'منابع (جداشده با فاصله)',
    sign_out_to_apply: 'برای اعمال تغییرات از حساب خارج شوید.',
    refresh_token_grant: 'مجوز با توکن نوسازی',
    organization_id: 'شناسه سازمان',
    console_result: 'نتیجه را در کنسول مرورگر ببینید.',
    request_token: 'درخواست توکن',
    user_info: 'اطلاعات کاربر',
    get_id_token_claims: 'دریافت ادعاهای توکن هویت',
    fetch_user_info: 'دریافت اطلاعات کاربر',
    device_initializing: 'در حال راه‌اندازی مجوز دستگاه…',
    device_success: 'با موفقیت وارد برنامه نمایشی شدید.',
    sign_in_information: 'اطلاعات ورود شما:',
    email: 'ایمیل',
    username: 'نام کاربری',
    user_id: 'شناسه کاربر',
    sign_out_demo: 'خروج از برنامه نمایشی',
    device_expired: 'کد دستگاه منقضی شد',
    generic_error: 'خطایی رخ داد',
    device_expired_description: 'کد دستگاه منقضی شده است. برای دریافت کد جدید دوباره تلاش کنید.',
    sign_in_title: 'وارد حساب خود شوید',
    scan_instruction: 'کد QR را اسکن کنید یا این نشانی را در دستگاه دیگری باز کنید:',
    one_time_code: 'کد یک‌بارمصرف را وارد کنید',
    token_info: 'اطلاعات توکن',
    get_access_token: 'دریافت توکن دسترسی',
    context_unavailable: 'بارگیری اطلاعات حساب امکان‌پذیر نیست.',
    not_initialized: 'اطلاعات حساب راه‌اندازی نشده است.',
    not_set: 'تنظیم نشده',
    configured: 'پیکربندی شده',
    password: 'گذرواژه',
    phone: 'شماره تلفن',
    search_help: 'جستجو در راهنما',
    language: 'زبان',
    menu: 'منو',
    compatibility_notice: 'یادداشت سازگاری: نام‌های به‌ارث‌رسیده از Logto برای کیت‌های توسعه، بسته‌ها، پروتکل‌ها، مؤلفه‌ها و سرآیندهای درخواست بدون تغییر می‌مانند.',
    source: 'منبع',
    upstream_repository: 'مخزن اصلی',
    current_fork: 'مخزن فعلی',
    license_notice: 'iden بر پایه Logto، نرم‌افزار متن‌باز دارای مجوز عمومی موزیلا 2.0، ساخته شده است.',
    about_description: 'اطلاعات محصول و انتساب منابع متن‌باز.',
    page_not_found: 'صفحه پیدا نشد',
    page_not_found_description: 'این صفحه در دسترس نیست. برای ادامه به مرکز راهنما بازگردید.',
    introduction: 'مقدمه',
    quick_starts: 'شروع سریع',
    integration: 'یکپارچه‌سازی',
    end_user_flows: 'جریان‌های کاربر نهایی',
    authorization: 'مجوزدهی',
    user_management: 'مدیریت کاربران',
    security: 'امنیت',
    customization: 'سفارشی‌سازی',
    connectors: 'اتصال‌دهنده‌ها',
    organizations: 'سازمان‌ها',
    self_hosting: 'میزبانی شخصی',
    continue: 'ادامه',
    loading: 'در حال بارگیری…',
    save: 'ذخیره',
    saved: 'ذخیره شد',
    try_again: 'تلاش دوباره',
    client_id: 'شناسه کلاینت',
    client_secret: 'رمز محرمانه کلاینت',
    redirect_uri: 'نشانی تغییر مسیر',
    status: 'وضعیت',
    type: 'نوع',
    permissions: 'مجوزها',
    token_data: 'داده‌های توکن',
    context_data: 'داده‌های زمینه',
    jwt_extra_claims: 'ادعاهای اضافی توکن',
    action_result: 'نتیجه عملیات',
    social_account_already_linked: 'این حساب اجتماعی قبلاً پیوند داده شده است.',
};
export default Object.freeze(interfacePhrases);
